module.exports = __webpack_public_path__ + "img/Bear30.64d0c1a9.jpg";